import { AbstractControl, FormControl } from '@angular/forms';

export class FormValidators {

    private static sameDigitsCPF = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444',
        '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];

    private static sameDigitsCNPJ = ['00000000000000', '11111111111111', '22222222222222', '33333333333333', '44444444444444',
        '55555555555555', '66666666666666', '77777777777777', '88888888888888', '99999999999999'];


    static teste(senha, confirmarSenha) {
        return { confirmarsenha: true };
    }
    static checkPasswords(AC: AbstractControl) {
        const pass = AC.get('senha').value;
        const confirmPass = AC.get('confirmarSenha').value;
        if (!AC.get('senha').value || !AC.get('senha').value.trim()) {
            return null;
        }
        // console.log(pass === confirmPass ? {confirmarsenha: true} : null);
        return pass === confirmPass ? { confirmarsenha: true } : null;
    }

    static cpfCnpjValidator(formControl: FormControl) {

        if (!formControl.value || !formControl.value.trim()) {
            return null;
        }

        if (formControl.value.replace(/[^a-zA-Z0-9]/g, '').length > 11) {
            return FormValidators.cnpjValidator(formControl);
        }

        return FormValidators.cpfValidator(formControl);
    }


    static cpfValidator(formControl: FormControl) {

        if (!formControl.value || !formControl.value.trim()) {
            return null;
        }

        const cpf = formControl.value.replace(/\D/gi, '');

        if (cpf.length < 11 || cpf.length > 11) {
            return { length: true };
        }

        if (FormValidators.sameDigitsCPF.indexOf(cpf) >= 0) {
            return { cpf: true };
        }

        let numeros = cpf.substring(0, 9);
        const digitos = cpf.substring(9);
        let soma = 0;

        for (let i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado.toString() !== digitos.charAt(0)) {
            return { cpf: true };
        }

        numeros = cpf.substring(0, 10);
        soma = 0;

        for (let i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado.toString() !== digitos.charAt(1)) {
            return { cpf: true };
        }
        return null;
    }

    static cnpjValidator(formControl: FormControl) {

        if (!formControl.value || !formControl.value.trim()) {
            return null;
        }

        // Remove máscara e mantém letras e números
        const cnpj = formControl.value
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase();

        if (cnpj.length !== 14) {
            return { length: true };
        }

        // Rejeita CNPJ formado pelo mesmo caractere
        let todosIguais = true;

        for (let i = 1; i < cnpj.length; i++) {
            if (cnpj.charAt(i) !== cnpj.charAt(0)) {
                todosIguais = false;
                break;
            }
        }

        if (todosIguais) {
            return { cnpj: true };
        }

        // Converte o caractere para o valor utilizado no cálculo:
        // número: ASCII - 48
        // letra:  ASCII - 48
        const valorCaractere = (caractere: string): number => {
            return caractere.charCodeAt(0) - 48;
        };

        // Calcula um dígito verificador
        const calcularDigito = (valor: string): number => {

            let soma = 0;
            let peso = 2;

            for (let i = valor.length - 1; i >= 0; i--) {

                soma += valorCaractere(valor.charAt(i)) * peso;

                peso++;

                if (peso > 9) {
                    peso = 2;
                }
            }

            const resto = soma % 11;

            return resto < 2 ? 0 : 11 - resto;
        };

        const base = cnpj.substring(0, 12);
        const digitosInformados = cnpj.substring(12);

        const primeiroDigito = calcularDigito(base);

        if (primeiroDigito.toString() !== digitosInformados.charAt(0)) {
            return { cnpj: true };
        }

        const segundoDigito = calcularDigito(base + primeiroDigito);

        if (segundoDigito.toString() !== digitosInformados.charAt(1)) {
            return { cnpj: true };
        }

        return null;
    }

    static emailValidator(formControl: FormControl) {
        if (!formControl.value || !formControl.value.trim()) {
            return { required: true };
        }

        if (!formControl.value.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)) {
            return { email: true };
        }

        return null;
    }

}
